/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallengeClipSource } from '../../subtitle-extractions/clip-source-enums';
import { challengeClipSourceSchema } from '../../subtitle-extractions/clip-source-enums';
import { triageChallengeSchema } from '../getCollectionTriageNext/get-collection-triage-next-response';
import type {
  ITriageChallengeV2,
  ITriageClipV2,
} from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';
import { triageClipV2Schema } from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';

export const triageClipV3Schema = triageClipV2Schema.extend({
  source: challengeClipSourceSchema,
});

export const triageItemV3Schema = z
  .object({
    clip: triageClipV3Schema,
    challenge: triageChallengeSchema,
  })
  .nullable();

export const getCollectionTriageNextV3ResponseSchema = createApiResponseSchema(
  triageItemV3Schema,
) as z.ZodSchema<IAPI<ITriageItemV3 | null>>;

export type ITriageClipV3 = ITriageClipV2 & { source: IChallengeClipSource };

export interface ITriageItemV3 {
  clip: ITriageClipV3;
  challenge: ITriageChallengeV2;
}

export type IGetCollectionTriageNextV3Response = IAPI<ITriageItemV3 | null>;
